module.exports = __webpack_public_path__ + "static/media/A0-YouTube__API.b2a06108.svg";